import CreditCardShape from '../definitions/CreditCardShape';
import verifyCardIntegrity from './verifyCardIntegrity';
import createCardInfoFromAPIResponse from './createCardInfoFromAPIResponse';


/**
 * Convert an array of BE data for credit cards into a FE array of CreditCardShape, while
 * discarding any cards that fail verifyCardIntegrity().
 * Should an array entry be null or undefined, we just ignore it. Apparently this can sometimes happen
 * when enriching featured products.
 * @param {object[]} results - API response data for credit cards
 * @param {object} [userInfo] - user info for credit cards
 * @param {boolean} [isValidApprovalLikelihood=false] - did the BE have a valid approval likelihood document?
 * @returns {CreditCardShape[]} - array of valid FE credit cards
 */
function createCreditCardsAndVerify(
    results,
    userInfo,
    isValidApprovalLikelihood = false
) {
    return results
        .filter(apiResponse => !!apiResponse)
        .map(apiResponse => createCardInfoFromAPIResponse(apiResponse, userInfo, isValidApprovalLikelihood))
        .filter(cardInfo => verifyCardIntegrity(cardInfo, cardInfo.displayType));
}


export default createCreditCardsAndVerify;
